import { render } from "./QualityGroupsEditing.vue?vue&type=template&id=523965ba&ts=true"
import script from "./QualityGroupsEditing.vue?vue&type=script&lang=ts"
export * from "./QualityGroupsEditing.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__